import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  verifyTokenLoad,
  userSubscriptionPurchaseLoad,
  bookSlotLoad,
  rescheduleSlotLoad,
  cancelSlotLoad,
} from "../../redux/slices/subscription.slice";
import { useLocation } from "react-router-dom";

export function SimpleLoader() {
  return (
    <div
      className="
        fixed inset-0 
        bg-gradient-to-br from-[#4c4d8a]/90 to-[#c04d68]/90
        flex items-center justify-center 
        z-50
      "
    >
      <style>
        {`
          @keyframes spinGradient {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>

      {/* Loader Ring */}
      <div
        className="
          h-20 w-20 rounded-full border-4 
          border-t-transparent
          border-l-transparent
          border-r-[#fde5ea] 
          border-b-[#d9d8ff]
          shadow-xl
        "
        style={{
          animation: "spinGradient 1s linear infinite",
        }}
      ></div>
    </div>
  );
}

function AccessDeniedCard() {
  return (
    <div className="min-h-screen pricing-bg relative overflow-hidden flex items-center justify-center px-4 py-12">
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/10"></div>

      {/* Glow blobs */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      {/* Card */}
      <div className="relative z-10 bg-white/10 backdrop-blur-xl rounded-3xl p-10 max-w-lg w-full border-2 border-white/30 shadow-2xl text-center">
        {/* Icon */}
        <div className="flex justify-center mb-8">
          <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-white/30 to-white/10 backdrop-blur-sm flex items-center justify-center border border-white/40">
            <span className="text-white text-3xl font-bold">!</span>
          </div>
        </div>

        {/* Heading */}
        <h1 className="text-4xl font-bold text-white mb-3">
          Sign In to Continue
        </h1>

        {/* Description */}
        <p className="text-white/70 text-lg leading-relaxed mb-10">
          You’re not logged in yet. Please sign in to continue or open the app
          using your active MentalFit account.
        </p>

        {/* CTA */}
        <button
          onClick={() => (window.location.href = "https://mpubx.app.link/open")}
          className="w-full py-4 rounded-xl font-bold text-lg transition-all duration-300
                     bg-white text-[#A66296] hover:bg-white/90 shadow-lg
                     hover:shadow-xl hover:scale-105"
        >
          Go to Login
        </button>
      </div>
    </div>
  );
}

function PaymentScreen() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { verificationLoading, verificationData, purchaseLoading } =
    useSelector((state) => state?.subscriptionReducer || {});

  const params = new URLSearchParams(location.search);
  const token = params.get("token");
  const finalAmount = params.get("amount");
  const plan = params.get("plan");
  console.log(params.get("type"), "something");
  const planTypeRaw = params.get("planType");

  const planType =
    planTypeRaw && planTypeRaw !== "null"
      ? (() => {
          try {
            return JSON.parse(planTypeRaw);
          } catch {
            return planTypeRaw;
          }
        })()
      : params.get("type") || "user";
  const promoCode = params.get("promoCode");

  const date = params.get("date");
  const proId = params.get("proId");
  const slotDuration = params.get("slotDuration");
  const bookingId = params.get("bookingId");

  const fullName = params.get("fullName");
  const expertise = params.get("expertise");
  const age = params.get("age");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (planType === "pro" || planType === "user") {
      if (promoCode) {
        dispatch(
          userSubscriptionPurchaseLoad({
            plan: plan?.split(" ")?.[1]?.toLowerCase(),
            token,
            planType,
            promoCode,
          })
        );
      } else {
        dispatch(
          userSubscriptionPurchaseLoad({
            plan: plan?.split(" ")?.[1]?.toLowerCase(),
            token,
            planType,
          })
        );
      }
    } else if (planType === "bookSlot") {
      dispatch(
        bookSlotLoad({
          date: new Date(date).toISOString(),
          proId,
          slotDuration,
          price: finalAmount,
          token,
          fullName,
          expertise,
          age,
        })
      );
    } else if (planType === "rescheduleSlot") {
      dispatch(
        rescheduleSlotLoad({
          bookingId: bookingId,
          date: date,
          token,
        })
      );
    }
  };

  useEffect(() => {
    dispatch(verifyTokenLoad({ token }));
  }, [dispatch]);

  if (verificationLoading) return <SimpleLoader />;

  if (!verificationLoading && !verificationData?.isVerify)
    return <AccessDeniedCard />;

  return (
    // <div className="min-h-screen bg-gradient-to-br from-[#6162ac] to-[#f16480] flex items-center justify-center px-4 py-12">
    //   <div className="bg-white/95 backdrop-blur-xl shadow-2xl rounded-3xl p-10 max-w-lg w-full text-center">
    //     {/* Header */}
    //     <h1 className="text-3xl sm:text-4xl font-bold bg-gradient-to-r from-[#6162ac] to-[#f16480] bg-clip-text text-transparent mb-8">
    //       {planType === "rescheduleSlot"
    //         ? "Reschedule slot"
    //         : "Payment Summary"}
    //     </h1>

    //     {/* Amount Box */}
    //     {planType !== "rescheduleSlot" && (
    //       <div className="bg-white border border-gray-200 rounded-2xl p-8 shadow-md mb-10">
    //         <>
    //           <p className="text-gray-600 text-lg mb-2">{"Your Plan"}</p>

    //           {plan && (
    //             <p className="text-gray-800 text-lg font-semibold mb-4">
    //               {plan}
    //             </p>
    //           )}
    //         </>

    //         <p className="text-gray-600 text-lg mb-2">Total Today</p>
    //         <p className="text-5xl font-extrabold bg-gradient-to-r from-[#6162ac] to-[#f16480] bg-clip-text text-transparent">
    //           ${finalAmount}
    //         </p>
    //       </div>
    //     )}

    //     {/* Complete Purchase Button */}
    //     <button
    //       onClick={handleSubmit}
    //       disabled={purchaseLoading}
    //       type="submit"
    //       className="w-full py-4 rounded-xl font-bold text-white text-lg shadow-xl
    //                  bg-gradient-to-r from-[#6162ac] to-[#f16480]
    //                  hover:scale-105 hover:shadow-2xl transition-all duration-300"
    //     >
    //       {purchaseLoading ? "Loading..." : "Complete Purchase"}
    //     </button>
    //   </div>
    // </div>
    <div className="min-h-screen pricing-bg relative overflow-hidden flex items-center justify-center px-4 py-12">
      <div className="absolute inset-0 bg-black/10"></div>

      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 bg-white/10 backdrop-blur-xl rounded-3xl p-10 max-w-lg w-full border-2 border-white/30 shadow-2xl">
        {/* Header Icon */}
        <div className="flex justify-center mb-8">
          <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-white/30 to-white/10 backdrop-blur-sm flex items-center justify-center border border-white/40">
            <svg
              className="w-8 h-8 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
        </div>

        {/* Header */}
        <h1 className="text-4xl font-bold text-white mb-2 text-center">
          {planType === "rescheduleSlot"
            ? "Reschedule Slot"
            : "Complete Your Purchase"}
        </h1>

        <p className="text-white/70 text-center mb-8 text-lg">
          {planType === "rescheduleSlot"
            ? "Choose your new time slot"
            : "Review and confirm your payment"}
        </p>

        {/* Amount Box */}
        {planType !== "rescheduleSlot" && (
          <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 border border-white/20 mb-10 space-y-6">
            {plan ? (
              <>
                <div>
                  <p className="text-white/70 text-sm font-medium mb-2">
                    Selected Plan
                  </p>
                  {plan && (
                    <p className="text-white text-2xl font-bold">{plan}</p>
                  )}
                </div>
                <div className="h-px bg-gradient-to-r from-transparent via-white/20 to-transparent"></div>
              </>
            ) : null}

            <div>
              <p className="text-white/70 text-sm font-medium mb-3">
                Total Amount
              </p>
              <p className="text-6xl font-extrabold text-white mb-2">
                ${finalAmount}
              </p>
              <p className="text-white/60 text-sm">Due today</p>
            </div>
          </div>
        )}

        {/* Complete Purchase Button */}
        <button
          onClick={handleSubmit}
          disabled={purchaseLoading}
          type="submit"
          className="w-full py-4 rounded-xl font-bold text-lg transition-all duration-300 mb-6
                 bg-white text-[#A66296] hover:bg-white/90 shadow-lg hover:shadow-xl hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {purchaseLoading ? (
            <span className="flex items-center justify-center gap-2">
              <div className="w-5 h-5 border-2 border-white border-t-[#A66296] rounded-full animate-spin"></div>
              Processing...
            </span>
          ) : (
            "Complete Purchase"
          )}
        </button>

        {/* Powered by Stripe */}
        <div className="flex items-center justify-center gap-2 bg-white/10 backdrop-blur-lg px-4 py-3 rounded-xl border border-white/20">
          <span className="text-white/70 text-xs font-medium">Powered by</span>
          <svg
            className="h-5"
            viewBox="0 0 60 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M59.64 14.28h-8.06c.19 1.93 1.6 2.55 3.2 2.55 1.64 0 2.96-.37 4.05-.95v3.32a8.33 8.33 0 0 1-4.56 1.1c-4.01 0-6.83-2.5-6.83-7.48 0-4.19 2.39-7.52 6.3-7.52 3.92 0 5.96 3.28 5.96 7.5 0 .4-.04 1.26-.06 1.48zm-5.92-5.62c-1.03 0-2.17.73-2.17 2.58h4.25c0-1.85-1.07-2.58-2.08-2.58zM40.95 20.3c-1.44 0-2.32-.6-2.9-1.04l-.02 4.63-4.12.87V5.57h3.76l.08 1.02a4.7 4.7 0 0 1 3.23-1.29c2.9 0 5.62 2.6 5.62 7.4 0 5.23-2.7 7.6-5.65 7.6zM40 8.95c-.95 0-1.54.34-1.97.81l.02 6.12c.4.44.98.78 1.95.78 1.52 0 2.54-1.65 2.54-3.87 0-2.15-1.04-3.84-2.54-3.84zM28.24 5.57h4.13v14.44h-4.13V5.57zm0-4.7L32.37 0v3.36l-4.13.88V.88zm-4.32 9.35v9.79H19.8V5.57h3.7l.12 1.22c1-1.77 3.07-1.41 3.62-1.22v3.79c-.52-.17-2.29-.43-3.32.86zm-8.55 4.72c0 2.43 2.6 1.68 3.12 1.46v3.36c-.55.3-1.54.54-2.89.54a4.15 4.15 0 0 1-4.27-4.24l.01-13.17 4.02-.86v3.54h3.14V9.1h-3.13v5.85zm-4.91.7c0 2.97-2.31 4.66-5.73 4.66a11.2 11.2 0 0 1-4.46-.93v-3.93c1.38.75 3.1 1.31 4.46 1.31.92 0 1.53-.24 1.53-1C6.26 13.77 0 14.51 0 9.95 0 7.04 2.28 5.3 5.62 5.3c1.36 0 2.72.2 4.09.75v3.88a9.23 9.23 0 0 0-4.1-1.06c-.86 0-1.44.25-1.44.9 0 1.85 6.29.97 6.29 5.88z"
              fill="white"
            />
          </svg>
          <div className="h-4 w-px bg-white/20"></div>
          <span className="text-white/60 text-xs">Secure Payment</span>
        </div>
      </div>
    </div>
  );
}

export default PaymentScreen;
